// import React, { Component } from 'react';
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Config from "../../Config.js";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import swal from "sweetalert";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { VideoTag } from "react-video-tag";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

import TextareaAutosize from "react-textarea-autosize";
import { CheckCheckAPDynamicQrCodeCountenabled } from "../../api/packageApi";

import { GetDominUrl } from "../../api/apiconfiguration.js";

import QRCode from "qrcode.react";
import jsPDF from "jspdf";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";

import "@pathofdev/react-tag-input/build/index.css";
import { editorConfiguration } from "components/EditorConfiguration.js";

const Addnewarticle = (props) => {
  let history = useHistory();
  const location = useLocation();
  const [EditArticleDetailsCallDone, setEditArticleDetailsCallDone] =
    useState(false);
  const [ProductID, setProductID] = useState(location?.state?.ProductID);
  //True False
  const [isArticleDisable, setisArticleDisable] = useState(false);
  const [ArticleName, setArticleName] = useState("");

  const [QrCodeModalisOpen, setQrCodeModalisOpen] = useState(false);

  const [SegmentModalisOpen, setSegmentModalisOpen] = useState(false);
  const [SegmentEditisOpen, setSegmentEditisOpen] = useState(false);
  const [SegmentEditDetailsisOpen, setSegmentEditDetailsisOpen] =
    useState(false);
  const [
    ArticleSegmentDocumentEditNameisOpen,
    setArticleSegmentDocumentEditNameisOpen,
  ] = useState(false);
  const [show, setshow] = useState(false);
  const [IsNameAndCatDisplay, setIsNameAndCatDisplay] = useState(true);
  const [IsPriceDisplay, setIsPriceDisplay] = useState(true);
  const [IsLabelDisplay, setIsLabelDisplay] = useState(false);
  const [IsSKUDisplay, setIsSKUDisplay] = useState(false);
  const [IsCertificateDisplay, setIsCertificateDisplay] = useState(true);
  const [IsSizeTabelDisplay, setIsSizeTabelDisplay] = useState(true);
  const [IsArticleTypeDisplay, setIsArticleTypeDisplay] = useState(false);
  const [IsArticleImageDisplay, setIsArticleImageDisplay] = useState(true);
  const [IsArticleSegmentImageDisplay, setIsArticleSegmentImageDisplay] =
    useState(true);
  const [
    IsArticleSegmentDescriptionDisplay,
    setIsArticleSegmentDescriptionDisplay,
  ] = useState(true);
  const [IsArticleSegmentVideoDisplay, setIsArticleSegmentVideoDisplay] =
    useState(true);
  const [IsArticleSegmentWebLinkDisplay, setIsArticleSegmentWebLinkDisplay] =
    useState(true);
  const [IsArticleSegmentDocumentDisplay, setIsArticleSegmentDocumentDisplay] =
    useState(true);
  const [IsArticleDescriptionDisplay, setIsArticleDescriptionDisplay] =
    useState(true);
  const [
    IsArticleshortDescriptionDisplay,
    setIsArticleshortDescriptionDisplay,
  ] = useState(true);

  const [IsArticlechat, setIsArticlechat] = useState(true);
  const [Isrelatedproduct, setIsrelatedproduct] = useState(false);
  const [isArticlewhatsappchat, setIsArticlewhatsappchat] = useState(true);

  //  Arrey
  const [searchArticlenumber, setsearchArticlenumber] = useState([]);

  const [SubCategoryList, setSubCategoryList] = useState([]);
  const [ArticlesTypeList, setArticlesTypeList] = useState([]);

  const [LabelList, setLabelList] = useState([]);
  const [CurrencyDetailsList, setCurrencyDetailsList] = useState([]);
  const [ArticleSegmentDocumentlist, setArticleSegmentDocumentlist] = useState(
    []
  );
  const [ArticleSegmentDocumentlistTemp, setArticleSegmentDocumentlistTemp] =
    useState([]);
  const [articleSegmentList, setarticleSegmentList] = useState([]);
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [subcategorylistnew, setsubcategorylistnew] = useState([]);
  const [selectedAttributeList, setselectedAttributeList] = useState([]);
  const [CombinationList, setCombinationList] = useState([]);
  const [ArticlePicsImageList, setArticlePicsImageList] = useState([]);
  const [ArticlePicsImageListTemp, setArticlePicsImageListTemp] = useState([]);
  const [ArticleSegmentImageLists, setArticleSegmentImageLists] = useState([]);
  const [ArticleSegmentImageListsTemp, setArticleSegmentImageListsTemp] =
    useState([]);
  const [ArticleDocumentList, setArticleDocumentList] = useState([]);
  const [VideosegmentList, setVideosegmentList] = useState([]);
  const [VideosegmentListTemp, setVideosegmentListTemp] = useState([]);
  const [LogoFile, setLogoFile] = useState([]);

  //Empty
  const [ArticleNumber, setArticleNumber] = useState("");
  const [SubCategoryError, setSubCategoryError] = useState("");
  const [SubCategoryAddtimeError, setSubCategoryAddtimeError] = useState("");
  const [ArticleNameError, setArticleNameError] = useState("");
  const [SizetablefilePath, setSizetablefilePath] = useState("");
  const [SizeTabel, setSizeTabel] = useState("");
  const [ArticleID, setArticleID] = useState("");
  const [ArticleDocumentID, setArticleDocumentID] = useState("");
  const [ArticleSegmentID, setArticleSegmentID] = useState("");
  const [LogoPath, setLogoPath] = useState("");
  const [LogoPathError, setLogoPathError] = useState("");
  const [SegmentDescription, setSegmentDescription] = useState("");
  const [SegmentDescriptionError, setSegmentDescriptionError] = useState("");
  const [LableDescription, setLableDescription] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [MainCategory, setMainCategory] = useState("");
  const [MainCategoryError, setMainCategoryError] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [Categoryselectname, setCategoryselectname] = useState("");
  const [CategoryError, setCategoryError] = useState("");
  const [ArticleTypeError, setArticleTypeError] = useState("");
  const [ArticleSKU, setArticleSKU] = useState("");
  const [OldArticleSKU, setOldArticleSKU] = useState("");
  const [ArticleSKUError, setArticleSKUError] = useState("");
  const [ArticleShortDescription, setArticleShortDescription] = useState("");
  const [ArticleShortDescriptionError, setArticleShortDescriptionError] =
    useState("");

  const [ArticleUploadSegmentImagesError, setArticleUploadSegmentImagesError] =
    useState("");
  const [SubCategoryId, setSubCategoryId] = useState("");
  const [ArticlesTypeId, setArticlesTypeId] = useState("");
  const [LabelId, setLabelId] = useState("");
  const [OldLabelName, setOldLabelName] = useState("");
  const [LabelError, setLabelError] = useState("");
  const [LabelName, setLabelName] = useState("");
  const [LabelNamError, setLabelNamError] = useState("");
  const [CurrencyName, setCurrencyName] = useState("");
  const [CurrencyNameError, setCurrencyNameError] = useState("");
  const [RegularPrice, setRegularPrice] = useState("");
  const [SellPrice, setSellPrice] = useState("");
  const [RegularPriceError, setRegularPriceError] = useState("");
  const [CurrencyId, setCurrencyId] = useState("");
  const [SellPriceError, setSellPriceError] = useState("");
  const [CurrencyError, setCurrencyError] = useState("");
  const [webLink, setwebLink] = useState("");
  const [youTubleVideoLink, setyouTubleVideoLink] = useState("");
  const [youTubleVideoLinkError, setyouTubleVideoLinkError] = useState("");
  const [WebLinkError, setWebLinkError] = useState("");
  const [websitelinkname, setwebsitelinkname] = useState("");
  const [websitelinknameError, setwebsitelinknameError] = useState("");
  const [Title, setTitle] = useState("");
  const [TitleError, setTitleError] = useState("");
  const [DocumentName, setDocumentName] = useState("");
  const [CertificateList, setCertificateList] = React.useState([]);
  const [istraveldistanceenable, setistraveldistanceenable] = useState(false);
  const [isenablemadeindisplay, setisenablemadeindisplay] = useState(false);
  const [isarticledistancedisplay, setisarticledistancedisplay] =
    useState(false);
  const [isAttributeshow, setisAttributeshow] = useState(false);
  const [CertificateName, setCertificateName] = useState("");
  const [CertificateNameError, setCertificateNameError] = useState("");
  const [CertificateLogoPath, setCertificateLogoPath] = useState("");
  const [CertificateLogoFile, setCertificateLogoFile] = useState([]);
  const [CertificateLogoFileError, setCertificateLogoFileError] = useState("");
  const [DocumentFile, setDocumentFile] = useState([]);
  const [DocumentFileError, setDocumentFileError] = useState([]);
  const [UserDcoumnetName, setUserDcoumnetName] = useState("");
  const [CertificateDocumentpath, setCertificateDocumentpath] = useState([]);
  const [modalSignupAdd, setmodalSignupAdd] = useState(false);
  const [CertificateWebsiteError, setCertificateWebsiteError] = useState("");
  const [CertificateWebsite, setCertificateWebsite] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const [QrCodeString, setQrCodeString] = useState("");
  const [QrCodeStringArticle, setQrCodeStringArticle] = useState("");

  const [issalf, setissalf] = useState(true);
  const [UserCompanyID, setUserCompanyID] = useState(false);
  const [selectCombinationID, setselectCombinationID] = useState("");

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);
  const [isToEamilAttribute, setisToEamilAttribute] = useState(false);

  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);

  const [ShortDescriptionisloding, setShortDescriptionisloding] =
    useState(false);

  const [Attributeisloding, setAttributeisloding] = useState(false);
  const [Certificatesisloding, setCertificatesisloding] = useState(false);

  const reactTags = React.createRef();

  const domainFrontUrl = useRef("");

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      getDominUrl();
    }
  }, []);

  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (
      response !== null &&
      response.domainName !== null &&
      response.domainName !== ""
    ) {
      domainFrontUrl.current = response.domainName;
    } else {
      domainFrontUrl.current = "";
    }
  };

  useEffect(() => {
    console.log("CombinationList", CombinationList);
  }, [CombinationList]);

  //Api Start

  const ArticlenumberhandleInputChange = (event) => {
    setsearchArticlenumber([]);
    setArticleNumber(event.target.value);
    setArticleName(event.target.value);
    const ArticleNumberObj = event.target.value;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleNumberObj !== "") {
      fetch(
        Config.apiUrl +
          "ArticleProduct/GetAllArticlesNumberPagination?SearchQuery=" +
          ArticleNumberObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => response.json())
        .then((Articlenumberlist) => {
          if (Articlenumberlist.length > 0) {
            const filteredData = Articlenumberlist.filter((element) => {
              return element.articleNumber
                .toLowerCase()
                .includes(ArticleNumberObj.toLowerCase());
            });
            setsearchArticlenumber(filteredData);
          } else {
            //setArticlesnum(false);
            const filteredData = [];
            setsearchArticlenumber(filteredData);
          }
        });
    } else {
      const filteredData = [];
      //setArticlesnum(false);
      setsearchArticlenumber(filteredData);
    }
  };

  const getAllArticlesTypeDropdownlist = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "GenericListing/DropdownList?categoryName=" +
        "ArticleType",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setArticlesTypeList(result);
        } else {
          setArticlesTypeList([]);
        }
      });
    });
  };
  const onEditBindAttributeValue = (ArticleIDObj) => {
    setCombinationList([]);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "Attribute/ArticleAttributeList?ArticleID=" +
        ArticleIDObj +
        "&ArticleTypeID=" +
        "",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((result) => {
      result.json().then((resp) => {
        if (resp.articleID != null && resp.articleID != "") {
          if (resp.attributeCombinationList.length > 0) {
            for (
              let index = 0;
              index < resp.attributeCombinationList.length;
              index++
            ) {
              // const element = resp.attributeCombinationList[index];
              let ImageUrl =
                Config.contentUrl +
                resp.attributeCombinationList[index].attributeImagePath;
              resp.attributeCombinationList[index].attributeImagePath =
                ImageUrl;
            }
            setCombinationList(resp.attributeCombinationList);
          }

          setselectedAttributeList(resp.attributeMappingList);
        }
      });
    });
  };
  const getAllArticleSegmentList = (articleidObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "ArticleProductSegment?articleProductID=" + articleidObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result.length > 0) {
          setarticleSegmentList(result);
          var first = result[0];
          if (first != null && first !== undefined) {
            ArticleSegmentgetbyId(first._id);
          } else {
            setarticleSegmentList([]);
          }
        } else {
          setarticleSegmentList([]);
        }
      });
    });
  };
  // Segmentget Any changed call method

  const ArticleSegmentgetbyId = (ArticleSegmentID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "ArticleProductSegment/SegmentFileById?segmentid=" +
        ArticleSegmentID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "userCompanyID": loginid,
          userCompanyID: loginid,

          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((response) => {
      response.json().then((result) => {
        if (result !== null) {
          //setArticleID(result.articleID);
          if (result.description != null) {
            setSegmentDescription(result.description);
          } else {
            setSegmentDescription("");
          }

          if (result.articleVideo != null) {
            console.log("result.articleVideo", result.articleVideo);
            setVideosegmentList(result.articleVideo);
          } else {
            setVideosegmentList([]);
          }
          if (result.articleDocument != null) {
            setArticleSegmentDocumentlist(result.articleDocument);
          } else {
            setArticleSegmentDocumentlist([]);
          }
          if (result.articleExternalLinkList != null) {
            setarticleSegmentWebLinkList(result.articleExternalLinkList);
          } else {
            setarticleSegmentWebLinkList([]);
          }
          if (result.articleSegmentImage != null) {
            setArticleSegmentImageLists(result.articleSegmentImage);
          } else {
            setArticleSegmentImageLists([]);
          }

          setIsArticleSegmentDescriptionDisplay(
            result.isArticleSegmentDescriptionDisplay
          );
          setIsArticleSegmentDocumentDisplay(
            result.isArticleSegmentDocumentDisplay
          );
          setIsArticleSegmentImageDisplay(result.isArticleSegmentImageDisplay);
          setIsArticleSegmentVideoDisplay(result.isArticleSegmentVideoDisplay);
          setIsArticleSegmentWebLinkDisplay(
            result.isArticleSegmentWebLinkDisplay
          );
          setArticleSegmentID(ArticleSegmentID);
          setIsloading(false);
        }
      });
    });
  };
  const getqrcodearticle = (articleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (articleID !== null && articleID !== "" && articleID !== undefined) {
      fetch(
        Config.apiUrl +
          "QrCodeResourceController/GetQrcodestring?targetId=" +
          articleID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          //Do something with the response
          if (responseJson !== null && responseJson !== "") {
            if (responseJson?.codeString) {
              let qrcodestring =
                domainFrontUrl.current + responseJson.codeString;
              setQrCodeStringArticle(qrcodestring);
            } else {
              setQrCodeStringArticle("");
            }
          } else {
            setQrCodeStringArticle("");
          }
        })
        .catch((error) => {
          setQrCodeStringArticle("");
          console.log(error);
        });
    } else {
      setQrCodeStringArticle("");
    }
    //
  };
  //End
  const ArticlenumbergetbyID = (_idObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (_idObj !== "" || _idObj !== null || _idObj !== undefined) {
      fetch(Config.apiUrl + "ArticleProduct/ById?id=" + _idObj, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((result) => {
          if (result != null) {
            setsearchArticlenumber([]);
            if (result.userCompanyID === loginid) {
              setissalf(true);
            }
            setUserCompanyID(result.userCompanyID);
            getAllArticleSegmentList(_idObj);
            getqrcodearticle(_idObj);

            setArticleNumber(result.articleNumber);
            setisArticleDisable(true);
            setArticleName(result.articleName);
            setLabelId(result.labelID);
            if (
              result.labelID !== null &&
              result.labelID !== "" &&
              result.labelID !== undefined
            ) {
              setOldLabelName(
                result.labelDetail?.name ? result.labelDetail?.name : ""
              );
            }
            setArticlesTypeId(result.articleTypeID);

            setCurrencyId(result.currencyID);
            if (
              result?.regularPrice &&
              result?.regularPrice !== "0" &&
              result?.regularPrice !== 0
            ) {
              setRegularPrice(result.regularPrice);
            } else {
              setRegularPrice("");
            }

            if (
              result?.sellPrice &&
              result?.sellPrice !== "0" &&
              result?.sellPrice !== 0
            ) {
              setSellPrice(result?.sellPrice);
            } else {
              setSellPrice("");
            }

            if (result.categorydetail != null && result.categorydetail != "") {
              setCategoryselectname(result.categorydetail.name);
            }

            getAllCertificateList(result._id, result.userCompanyID);
            //getArticleSizeImage(result._id, result.userCompanyID);
            setArticleSKU(result.articleSKU);
            setOldArticleSKU(result?.articleSKU ? result?.articleSKU : "");
            setIsNameAndCatDisplay(result.isNameAndCatDisplay);
            setIsPriceDisplay(result.isPriceDisplay);
            setIsLabelDisplay(result.isLabelDisplay);
            setIsSKUDisplay(result.isSKUDisplay);
            setIsSizeTabelDisplay(result.isSizeTabelDisplay);
            setIsArticleTypeDisplay(result.isArticleTypeDisplay);
            setIsArticleDescriptionDisplay(result.isArticleDescriptionDisplay);
            setIsArticleImageDisplay(result.isArticleImageDisplay);
            if (result?.shortDescription) {
              setArticleShortDescription(result.shortDescription);
            } else {
              setArticleShortDescription("");
            }

            setIsArticleshortDescriptionDisplay(
              result.isShortDescriptionDisplay
            );
            setistraveldistanceenable(result.isTravelDistanceEnable);
            setisenablemadeindisplay(result.isEnableMadeIndisplay);
            setisarticledistancedisplay(result.isArticleDistanceDisplay);
            setIsCertificateDisplay(result.isCertificateDisplay);
            setIsArticlechat(result.isArticleChatDisplay);
            setIsrelatedproduct(result?.isRelatedProductDisplay);
            setIsArticlewhatsappchat(result?.isWhatsappChatDisplay);
            getAllArticlePicsList(result._id);
            setArticleID(result._id);
            // if (sub1 === "" || sub1 === undefined || sub1 === null) {
            //   setSubCategoryId("0");
            // } else {
            //   setSubCategoryId(sub1);
            // }
            setshow(true);
          }
        })
        .catch((error) => {
          console.log("Error=>", error);
        });
    }
  };

  const getAllCertificateList = (ArticaleIDObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "Certificate/GetAllCertificateweb?ArticaleID=" +
        ArticaleIDObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCertificateList(result);
          setIsloading(false);
        }
      });
    });
  };

  if (
    location?.state?.EditArticleDetailsID != "" &&
    location?.state?.EditArticleDetailsID !== undefined &&
    location?.state?.EditArticleDetailsID !== null
  ) {
    let EditArticleDetailsID = location?.state?.EditArticleDetailsID;
    if (
      EditArticleDetailsID !== null &&
      EditArticleDetailsID != "" &&
      EditArticleDetailsID != undefined &&
      EditArticleDetailsCallDone == false
    ) {
      let temp = EditArticleDetailsCallDone;
      temp = true;
      setEditArticleDetailsCallDone(temp);
      ArticlenumbergetbyID(EditArticleDetailsID);
    }
  }

  const createArticlesnumber = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleNumber != null &&
      ArticleNumber != "" &&
      ArticleNumber != undefined
    ) {
      fetch(
        Config.apiUrl +
          "ArticleProduct/CheckArticleNumber?articleNumber=" +
          ArticleNumber,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            // getAllArticlesTypeDropdownlist();
            // getAllCurrencyDropdownlist();

            var articlenumber = {
              ArticleNumber: ArticleNumber,
              UserCompanyID: loginid,
              IsProduct: false,
              ArticleName: ArticleNumber,
              isNameAndCatDisplay: IsNameAndCatDisplay,
              isArticleImageDisplay: IsArticleImageDisplay,
              isShortDescriptionDisplay: IsArticleshortDescriptionDisplay,
              isArticleDescriptionDisplay: IsArticleDescriptionDisplay,
              isCertificateDisplay: IsCertificateDisplay,
              isSizeTabelDisplay: IsSizeTabelDisplay,
              isPriceDisplay: IsPriceDisplay,
              isArticleChatDisplay: IsArticlechat,
              isWhatsappChatDisplay:isArticlewhatsappchat
              
            };
            fetch(Config.apiUrl + "ArticleProduct/Create", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(articlenumber),
            }).then((result) => {
              result
                .json()
                .then((resp) => {
                  if (resp != null) {
                    setsearchArticlenumber([]);
                    setUserCompanyID(resp.userCompanyID);
                    CretaeFixSegmentName(resp._id);
                    getAllCertificateList(resp._id);
                    setArticleNumber(resp.articleNumber);
                    setisArticleDisable(true);
                    setArticleID(resp._id);

                    setshow(true);
                    swal("Thank You", "Article Number is Created.", "success");
                  } else {
                    swal("oops!", "ArticleNumber already exists", "error");
                  }
                })
                .catch((error) => {
                  swal("oops!", "ArticleNumber already exists", "error");
                });
            });
          } else {
            swal("oops!", "ArticleNumber already exists", "error");
          }
        });
      });
    } else {
      swal("oops!", "Please Enter Article Number", "error");
    }
  };
  const NamecategoryhandleSubmit = (e) => {
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsNameAndCatDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "nameandcat" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsNameAndCatDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangeArticleName = (event) => {
    setArticleNameError("");
    setArticleName(event.target.value);
  };

  const IshortDescriptionandleSubmit = (e) => {
    //setIsArticleshortDescriptionDisplay(e.target.checked);
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsArticleshortDescriptionDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "shortdescription" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleshortDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangeArticleShortDescription = (event) => {
    console.log("event=>", event);
    setArticleShortDescription(event);
    setArticleShortDescriptionError("");
  };
  const createShortDescription = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      IsValid = false;
    }

    if (IsValid === true) {
      setShortDescriptionisloding(true);
      var data = {
        _id: ArticleID,
        ShortDescription: ArticleShortDescription,
        IsShortDescriptionDisplay: IsArticleshortDescriptionDisplay,
        UserCompanyID: loginid,
      };
      fetch(
        Config.apiUrl + "ArticleProduct/UpdateShortDescription?id=" + ArticleID,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }
      ).then((result) => {
        result.json().then((resp) => {
          setShortDescriptionisloding(false);
          if (resp != null)
            swal(
              "Saved",
              "Article's ShortDescription details are saved.",
              "success"
            );
          else
            swal(
              "Sorry!",
              "Article's ShortDescription details are not saved.",
              "error"
            );
        });
      });
    }
  };

  //toggle Method start

  const toggleQrCodeModal = () => {
    // setselectCombinationID("");
    setQrCodeModalisOpen(!QrCodeModalisOpen);
    setQrCodeString("");
  };

  const toggleSegmentModal = () => {
    setSegmentModalisOpen(!SegmentModalisOpen);
    setTitle("");
  };
  const toggleSegmentModalEdit = () => {
    setSegmentEditisOpen(!SegmentEditisOpen);
  };
  const toggleSegmentEditDetails = () => {
    if (SegmentEditDetailsisOpen === true) {
      setSegmentEditisOpen(true);
    }

    setSegmentEditDetailsisOpen(!SegmentEditDetailsisOpen);
    //getAllArticleSegmentList(ArticleID);
  };
  const toggleArticleSegmentDocumentEditName = () => {
    setArticleSegmentDocumentEditNameisOpen(
      !ArticleSegmentDocumentEditNameisOpen
    );
  };
  const getSubCategoryDropdownlistByCategoryID = (catId) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "Category/SubCategoryDrodownList?categoryID=" + catId,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          if (result.length > 0) {
            setSubCategoryList(result);
          } else {
            setSubCategoryList([]);
          }
        } else {
          setSubCategoryList([]);
        }
      });
    });
  };

  //End

  const createArticlesNameAndCategorySection = () => {
    let IsValid = true;
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      IsValid = false;
    }
    if (
      ArticleName === null ||
      ArticleName === "" ||
      ArticleName === undefined
    ) {
      IsValid = false;
      setArticleNameError("Please Enter Article Name");
    }

    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        CategoryID: CategoryId,
        SubCategoryID: SubCategoryId,
        IsNameAndCatDisplay: IsNameAndCatDisplay,
        UserCompanyID: loginid,
      };
      fetch(Config.apiUrl + "ArticleProduct/UpdateCatrgory?id=" + ArticleID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp)
            swal("Thank You", "Article's details are saved.", "success");
          else swal("Sorry!", "Article's details are not saved.", "error");
        });
      });
    }
  };

  const IsCertificateshandleSubmit = (e) => {
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsCertificateDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "certificate" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     setIsCertificateDisplay(!e.target.checked);
          // }
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsCertificateDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  //Create Article Image  Method
  const IsArticleImagehandleSubmit = (e) => {
    //setIsArticleImageDisplay(e.target.checked);
    //createArticleImagecheckboxupdate(ArticleID, e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    setIsArticleImageDisplay(e.target.checked);
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "image" +
        "&isPublish=" +
        e.target.checked,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((result) => {
      result.json().then((resp) => {
        if (resp === true) {
          swal("Congratulations ! update successfully.", {
            icon: "success",
          });
        } else {
          setIsArticleImageDisplay(!e.target.checked);
          swal("Sorry!", "Not update.", "error");
        }
      });
    });
  };

  const handleChangeArticleImageStatus = ({ meta, file }, status) => {
    console.log(status, meta, file);
  };
  const CreateArticlePics = (event) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());

    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            //code
            setIsloading(true);
            const formData = new FormData();
            formData.append("fileType", "articleimage");
            formData.append("targetId", ArticleID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            tempFiles.map((i) => {
              formData.append("body", i);
            });

            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                console.log(resp);
                getAllArticlePicsList(ArticleID);
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      setIsloading(false);
    }
  };
  //File Delete
  const ArticleImagedelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            if (resp === true) {
              getAllArticlePicsList(ArticleID);
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Article Images is safe!");
            }
          });
        });
      }
    });
  };

  const getAllArticlePicsList = (articleidObj) => {
    setArticlePicsImageList([]);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "FileUpload/?targetID=" +
        articleidObj +
        "&FileType=" +
        "articleimage",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setIsloading(false);
        if (result.length > 0) {
          setArticlePicsImageList(result);
        } else {
          setArticlePicsImageList([]);
        }
      });
    });
  };

  //End
  //Articlesegment create and update
  const onChangeArticlesegmentName = (event) => {
    setTitleError("");
    setTitle(event.target.value);
  };
  const createArticleSegmentName = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      IsValid = false;
    }
    if (Title === null || Title === "" || Title === undefined) {
      IsValid = false;
      setTitleError("Please Enter Segment Name");
    }
    if (IsValid === true) {
      var data = {
        //_id: ArticleID,
        Title: Title,
        ArticleID: ArticleID,
        UserCompanyID: loginid,
        IsArticleSegmentDisplay: true,
        IsArticleSegmentImageDisplay: true,
        IsArticleSegmentDescriptionDisplay: true,
        IsArticleSegmentVideoDisplay: true,
        IsArticleSegmentWebLinkDisplay: true,
        IsArticleSegmentDocumentDisplay: true,
      };

      fetch(
        Config.apiUrl +
          "ArticleProductSegment/CheckSegment?id=" +
          ArticleID +
          "&segmentName=" +
          Title,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(Config.apiUrl + "ArticleProductSegment/Create", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(data),
            }).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  getAllArticleSegmentList(resp.articleID);
                  toggleSegmentModal(false);

                  swal("Saved", "Article's Segment Name are saved.", "success");
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Name are not saved.",
                    "error"
                  );
              });
            });
          } else {
            swal("Your Segment name already exists !");
          }
        });
      });
    }
  };
  const onClickArticleSegmentNameEdit = (item) => {
    setTitle(item.title);
    setArticleSegmentID(item._id);
    //toggleSignup7();
    setSegmentEditisOpen(false);
    toggleSegmentEditDetails();
  };
  const ArticlesegmentNamedelete = (_idObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "ArticleProductSegment/Delete?id=" + _idObj, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            if (resp === true) {
              getAllArticleSegmentList(ArticleID);
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Article Segment Name is safe!");
            }
            //ArticledocumentsegmentListgetData();
          });
        });
      }
    });
  };
  const UpdateArticleSegmentName = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      IsValid = false;
    }
    if (Title === "" || Title === undefined || Title === null) {
      IsValid = false;
      setTitleError("Please Enter Segment Name");
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleSegmentID,
        ArticleID: ArticleID,
        Title: Title,
        UserCompanyID: loginid,
      };

      fetch(
        Config.apiUrl +
          "ArticleProductSegment/CheckSegment?id=" +
          ArticleID +
          "&segmentName=" +
          Title,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(
              Config.apiUrl +
                "ArticleProductSegment/UpdateName?id=" +
                ArticleSegmentID,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(data),
              }
            ).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  getAllArticleSegmentList(resp.articleID);
                  toggleSegmentEditDetails();
                  setSegmentEditisOpen(true);
                  swal("Saved", "Article's Segment Name are saved.", "success");
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Name are not saved.",
                    "error"
                  );
              });
            });
          } else {
            swal("Your Segment name already exists !");
          }
        });
      });
    }
  };
  //End

  //FixSegmentName create first time
  const CretaeFixSegmentName = (ArticleIDObj) => {
    let titleList = ["Detail"];
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
        "ArticleProductSegment/GenerateDefault?articleId=" +
        ArticleIDObj,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(titleList),
      }
    ).then((result) => {
      result.json().then((resp) => {
        console.log(resp);
        getAllArticleSegmentList(ArticleIDObj);
      });
    });
  };
  //End

  //Article Segment Description Disply
  const IsArticleDescriptionDisplyUpdate = (e) => {
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsArticleDescriptionDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "description" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  //End

  // Segmentget Tabe create
  const title = articleSegmentList.map((x) => {
    return (
      <Tab
        onClick={() => {
          ArticleSegmentgetbyId(x._id);
        }}
        key={x._id}
      >
        {x.title}
      </Tab>
    );
  });

  const text = articleSegmentList.map((x) => {
    return <TabPanel key={x._id}>{x.Title}</TabPanel>;
  });

  const displayPosts = (
    <Tabs defaultIndex={0} onSelect={(index) => console.log(index)}>
      <TabList>{title}</TabList>
      {text}
    </Tabs>
  );

  //End

  //Article Segment Image Method
  const IsArticleSegmentImagehandleSubmit = (e) => {
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentImageDisplay(e.target.checked);
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
          "ArticleProductSegment/UpdatePublish?id=" +
          ArticleSegmentID +
          "&type=" +
          "segmentimage" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentImageDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };

  const ArticlesegmentImagedelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      _idFileUplod != null &&
      _idFileUplod != "" &&
      _idFileUplod != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              ArticleSegmentgetbyId(ArticleSegmentID);
              if (resp === true) {
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article Segment Images is safe!");
              }
            });
          });
        }
      });
    }
  };

  const handleChangeArticleUploadSegmentImagesStatus = (
    { meta, file },
    status
  ) => {
    console.log(status, meta, file);
  };
  const CreateArticleSegmentImages = (event) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            //code
            setIsloading(true);
            const formData = new FormData();
            //formData.append('ArticleSegmentID', ArticleSegmentID);
            formData.append("fileType", "articlesegmentimage");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            //formData.append('IsArticleSegmentImageDisplay', IsArticleSegmentImageDisplay);
            tempFiles.map((i) => {
              formData.append("body", i);
            });

            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                //'Content-Type': 'application/json',
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                setIsloading(false);
                console.log(resp);
                if (resp) {
                  ArticleSegmentgetbyId(ArticleSegmentID);
                  swal("Saved", "Article'Segment Iamge are saved.", "success");
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Images are not saved.",
                    "error"
                  );
                //ArticleSegmentgetbyId(ArticleSegmentID);
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      setIsloading(false);
    }
  };
  //End

  //Segment Description Method
  const IsArticleSegmentDescriptionhandleSubmit = (e) => {
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentDescriptionDisplay(e.target.checked);
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
          "ArticleProductSegment/UpdatePublish?id=" +
          ArticleSegmentID +
          "&type=" +
          "segmentdescription" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangeSegmentDescription = (event) => {
    setSegmentDescriptionError("");
    setSegmentDescription(event);
  };
  const createdeSegmentDescription = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    var data = {
      _id: ArticleSegmentID,
      Description: SegmentDescription,
      IsArticleSegmentDescriptionDisplay: IsArticleSegmentDescriptionDisplay,
      UserCompanyID: loginid,
      ArticleID: ArticleID,
    };
    fetch(Config.apiUrl + "ArticleProductSegment/UpdateDescription/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp != null) {
          ArticleSegmentgetbyId(ArticleSegmentID);
          swal(
            "Saved",
            "Article' Segment Description  are Updated.",
            "success"
          );
        } else
          swal(
            "Sorry!",
            "Article's Segment Description are not saved.",
            "error"
          );
      });
    });
    // if (
    //   SegmentDescription != null &&
    //   SegmentDescription != "" &&
    //   SegmentDescription != undefined
    // ) {

    // } else {
    //   setSegmentDescriptionError("Please Enter Description");
    // }
  };
  //End

  //Article Segment Video Method start
  const IsArticleSegmentVideoUpdate = (e) => {
    //setIsArticleSegmentVideoDisplay(e.target.checked);
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentVideoDisplay(e.target.checked);
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");
      fetch(
        Config.apiUrl +
          "ArticleProductSegment/UpdatePublish?id=" +
          ArticleSegmentID +
          "&type=" +
          "segmentvideo" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     setIsArticleSegmentVideoDisplay(!e.target.checked);
          // }
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentVideoDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };

  const ArticlesegmentVideodelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      _idFileUplod != null &&
      _idFileUplod != "" &&
      _idFileUplod != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                ArticleSegmentgetbyId(ArticleSegmentID);
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article Segment Video is safe!");
              }
            });
          });
        }
      });
    }
  };

  const handleChangeArticleSegmentVideoUploadStatus = (
    { meta, file },
    status
  ) => {
    console.log(status, meta, file);
  };
  const CreateArticleSegmentVideo = (event) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;

      fetch(
        Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            //code
            setIsloading(true);
            const formData = new FormData();
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            formData.append("fileType", "articlesegmentvideo");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                console.log(resp);
                if (resp) {
                  ArticleSegmentgetbyId(ArticleSegmentID);
                  swal(
                    "Saved",
                    "Article's Segment Videos are saved.",
                    "success"
                  );
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Videos are not saved.",
                    "error"
                  );
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      setIsloading(false);
    }
  };
  //End

  //WebLink Method start
  const IsArticleSegmentWebLinkupdate = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentWebLinkDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProductSegment/UpdatePublish?id=" +
          ArticleSegmentID +
          "&type=" +
          "segmentexternallink" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentWebLinkDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangewebsitelinkname = (event) => {
    setwebsitelinknameError("");
    setwebsitelinkname(event.target.value);
  };
  const onChangeWebLink = (event) => {
    setWebLinkError("");
    // if (!new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?').test(event.target.value)) {
    //     setWebLinkError('Invalid');
    //     setwebLink(event.target.value);
    // }
    // else {
    //     setwebLink(event.target.value);
    // }
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      event.target.value !== undefined
    ) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(event.target.value)
      ) {
        setWebLinkError("Invalid weblink");
        setwebLink(event.target.value);
      } else {
        setwebLink(event.target.value);
      }
    } else {
      setwebLink(event.target.value);
    }

    // setwebLink(event.target.value);
  };
  const onChangeyouTubleVideoLink = (event) => {
    setyouTubleVideoLinkError("");
    let temp = [];
    temp.push(event.target.value);
    setyouTubleVideoLink(temp);
  };
  const createWebLink = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (webLink === "" || webLink === undefined || webLink === null) {
      IsValid = false;
      setWebLinkError("webLink must be filled out");
    } else {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(webLink)
      ) {
        setWebLinkError("Invalid weblink");
        IsValid = false;
      }
      if (WebLinkError.length > 0) {
        IsValid = false;
        setWebLinkError(WebLinkError);
      }
    }
    if (IsValid === true) {
      setIsloading(true);
      var data = {
        //_id: this.state._id,
        Name: websitelinkname,
        UserCompanyID: loginid,
        LinkURL: webLink,
        ArticleSegmentID: ArticleSegmentID,
      };
      fetch(Config.apiUrl + "ExternalLink/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            ArticleSegmentgetbyId(ArticleSegmentID);
            setwebLink("");
            setwebsitelinkname("");
            swal("Saved", "Article's WebLink details are saved.", "success");
          } else
            swal("Sorry!", "Article's WebLink details are not saved.", "error");
        });
      });
    } else {
      setIsloading(false);
    }
  };
  const createyouTubeVideoLink = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (
      youTubleVideoLink === "" ||
      youTubleVideoLink === undefined ||
      youTubleVideoLink === null
    ) {
      IsValid = false;
      setWebLinkError("youTubleVideoLink must be filled out");
    }
    if (IsValid === true) {
      setIsloading(true);
      var data = {
        //_id: this.state._id,
        // Name: websitelinkname,
        fileType: "articlesegmentvideo",
        UserCompanyID: loginid,
        youTubeLinkList: youTubleVideoLink,
        targetID: ArticleSegmentID,
      };
      fetch(Config.apiUrl + "FileUpload/SaveYouTubeLink", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            ArticleSegmentgetbyId(ArticleSegmentID);
            setyouTubleVideoLink("");
            // setwebsitelinkname('')
            swal("Saved", "Article's WebLink details are saved.", "success");
          } else
            swal("Sorry!", "Article's WebLink details are not saved.", "error");
        });
      });
    } else {
      setIsloading(false);
    }
  };
  const ArticleWeblinkdelete = (_idObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (_idObj != null && _idObj != "" && _idObj != undefined) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "ExternalLink/Delete?id=" + _idObj, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                ArticleSegmentgetbyId(ArticleSegmentID);
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your WebLink is safe!");
              }
              //ArticleWebLinkListgetData();
            });
          });
        }
      });
    }
  };
  // end

  //Documents Method start
  const IsArticleSegmentDocumentUpdate = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentDocumentDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProductSegment/UpdatePublish?id=" +
          ArticleSegmentID +
          "&type=" +
          "segmentdocument" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentDocumentDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
          // if (resp === false) {
          //     setIsArticleSegmentDocumentDisplay(!e.target.checked);
          // }
        });
      });
    }
  };
  const onChangeDocumentName = (event) => {
    setDocumentName(event.target.value);
  };
  const UpdateArticleDocumentFile = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    var data = {
      _id: ArticleDocumentID,
      ArticleSegmentID: ArticleSegmentID,
      FileName: DocumentName,
    };
    fetch(Config.apiUrl + "ArticleDocument/UpdateArticleDocument/", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp) {
          ArticleSegmentgetbyId(ArticleSegmentID);
          //setshow(true);
          toggleArticleSegmentDocumentEditName();
          //getAllArticleSegmentList(ArticleID);
          //ArticleDocumentSegmentIdByListgetData(ArticleSegmentID);
          swal("Saved", "Article'Segment Document are Updated.", "success");
        } else
          swal("Sorry!", "Article'Segment Document are not Updated.", "error");
      });
    });
  };
  const downloadEmployeeData = (filename, myUrl) => {
    let downloadURL = Config.contentUrl + filename;
    window.open(downloadURL, "_blank");
  };
  const ArticlesegmentDocumentdelete = (ArticlesegmentDocumentID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(
          Config.apiUrl + "FileUpload/Delete?id=" + ArticlesegmentDocumentID,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((result) => {
          result.json().then((resp) => {
            ArticleSegmentgetbyId(ArticleSegmentID);
            if (resp === true) {
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Article Segment Document is safe!");
            }
          });
        });
      }
    });
  };
  const onClickDocumentEdit = (item) => {
    setDocumentName(item.fileName);
    setArticleDocumentID(item._id);
    toggleArticleSegmentDocumentEditName();
  };

  const handleChangeArticleUploadDocumentStatus = ({ meta, file }, status) => {
    console.log(status, meta, file);
  };
  const CreateArticleDocument = (event) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            setIsloading(true);
            const formData = new FormData();
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            formData.append("fileType", "articlesegmentdocument");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                console.log(resp);
                if (resp) {
                  ArticleSegmentgetbyId(ArticleSegmentID);
                  swal(
                    "Saved",
                    "Article'Segment document are saved.",
                    "success"
                  );
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment document are not saved.",
                    "error"
                  );
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      setIsloading(false);
    }
  };
  //End

  //Distance
  const Enablemadeindisplaysubmit = (e) => {
    setisenablemadeindisplay(e.target.checked);
  };
  const Istraveldistanceenablesubmit = (e) => {
    setistraveldistanceenable(e.target.checked);
  };
  const Isarticledistancedisplaysubmit = (e) => {
    setisarticledistancedisplay(e.target.checked);
  };
  const onUpdateDistance = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    var data = {
      _id: ArticleID,
      IsArticleDistanceDisplay: isarticledistancedisplay,
      IsEnableMadeIndisplay: isenablemadeindisplay,
      IsTravelDistanceEnable: istraveldistanceenable,
      UserCompanyID: loginid,
    };
    fetch(Config.apiUrl + "ArticleProduct/UpdateDistance?id=" + ArticleID, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp != null) {
          if (resp._id != null && resp._id != "") {
            swal("Saved", "Article Distance are Updated.", "success");
          } else {
            swal("Sorry!", "Article Distance are not Updated.", "error");
          }
        } else swal("Sorry!", "Article Distance are not Updated.", "error");
      });
    });
  };
  const toggleSignupAdd = () => {
    Certificateclerefrom();
    setmodalSignupAdd(!modalSignupAdd);
  };
  const Certificateclerefrom = () => {
    setCertificateNameError("");
    setUserDcoumnetName("");
    setCertificateLogoPath("");
    setCertificateLogoFileError("");
    setCertificateLogoFile("");
    setCertificateWebsiteError("");
    setDocumentFileError("");
    setCertificateName("");
    setDocumentFile([]);
    setCertificateWebsite("");
    setCertificateWebsiteError("");
    setCertificateDocumentpath([]);
  };
  const CertificatesetFile = (event) => {
    setCertificateLogoPath(URL.createObjectURL(event.target.files[0]));
    setCertificateLogoFileError("");
    setCertificateLogoFile(event.target.files[0]);
  };

  const DcoumnetNameEdit = (event, i) => {
    let temp = [...CertificateDocumentpath];
    var tempData = CertificateDocumentpath[i];
    tempData.FileName = event.target.value;
    setUserDcoumnetName(event.target.value);
  };
  const CertificatesetFileDocument = (event) => {
    setDocumentFileError("");
    // let temp = [...CertificateDocumentpath];
    let temp = [];
    let tempDocumnetFile = DocumentFile;
    let selectedFile = event.target.files;
    for (let index = 0; index < selectedFile.length; index++) {
      let typeobj = selectedFile[index].type;
      if (typeobj === "application/pdf") {
        const element = URL.createObjectURL(selectedFile[index]);
        let dt = {
          _id: "",
          FileUrl: element,
          FileName: selectedFile[index].name,
        };
        setUserDcoumnetName(selectedFile[index].name);
        temp.push(dt);
        tempDocumnetFile.push(selectedFile[index]);
      }
    }
    setCertificateDocumentpath(temp);
    setDocumentFile(tempDocumnetFile);
  };
  const onChangeCertificateName = (event) => {
    setCertificateNameError("");
    setCertificateName(event.target.value);
  };
  const onChangeWebsiteName = (event) => {
    // setCertificateWebsiteError("");
    // setCertificateWebsite(event.target.value);
    if (event.target.value.length > 0) {
      if (
        // !/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(
        !/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9\-]+(\.[a-z\-]{2,}){1,3}(#?\/?[a-zA-Z0-9\-#]+)*\/?(\?[a-zA-Z0-9-_\-]+=[a-zA-Z0-9-%\-]+&?)?$/.test(
          event.target.value
        )
      ) {
        setCertificateWebsiteError("Invalid weblink");
        setCertificateWebsite(event.target.value);
      } else {
        setCertificateWebsiteError("");
        setCertificateWebsite(event.target.value);
      }
    } else {
      setCertificateWebsiteError("");
      setCertificateWebsite("");
    }
  };

  const QrcodegeneratorArticle = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    let ArticleQrcodestring = {
      UserCompanyID: loginid,
      TargetType: "ArticleQrCode",
      TargetID: ArticleID,
      CodeString: "",
      IsDeleted: false,
    };
    fetch(Config.apiUrl + "QrCodeResourceController/CreateQrcodestring", {
      headers: {
        userCompanyID: loginid,
        "Content-Type": "application/json",
        Authorization: "Bearer " + Auth0token,
      },
      method: "POST",
      body: JSON.stringify(ArticleQrcodestring),
    })
      .then((result) => {
        result.json().then((resp) => {
          if (resp !== null) {
            if (resp?.codeString) {
              // setQrCodeStringArticle(Config.FrontUrl + resp?.codeString);
              let qrcodestring = domainFrontUrl.current + resp.codeString;
              setQrCodeStringArticle(qrcodestring);
              setQrCodeModalisOpen(true);
            } else {
              setQrCodeStringArticle("");
            }
            swal("successfully", "Article  Qrcode created.", "success");
          } else {
            swal("error", "Article  Qrcode not generate.", "error");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };
  const downloadQRCodeArticle = () => {
    const qrCodeURL = document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };
  const printQrcode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    //var doc = new jsPDF('p','mm',[297, 210]);
    doc.setFontSize(22);
    doc.text(20, 30, ArticleName);
    doc.setFontSize(10);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 100, 100);
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const printQrcodeArticle = () => {
    const qrCodeURL = document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.text(20, 80, ArticleName);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 100, 100);
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };

  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    console.log("item", itemobj);
    return new URLSearchParams(itemobj[1]).get("v");
    //    console.log("IdPraveen=>",ID)
  };
  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };
  const toggleToEmailAttributecreate = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamilAttribute(!isToEamilAttribute);
  };

  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp.length !== unique.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };

  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <>
        <div key={i} className="removeSection">
          <input
            type="text"
            className="form-control mr-2"
            //maxlength="50"
            placeholder="Enter To Email"
            value={el || ""}
            onChange={SubToEmailhandleChange(i)}
          />
          {i > 0 ? (
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                SubToEmailremoveClick(i);
              }}
              className="btn btn-danger"
            >
              <i className="fa-trash fas"></i>
            </a>
          ) : (
            <></>
          )}
        </div>
      </>
    ));
  };

  const QRCodeArticleSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: ArticleName,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };
  const QRCodeArticleSendAttributecreate = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }

    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    // let Toemail = [];
    // Toemail.push("rprajapati@eagletechsolutions.uk")

    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: ArticleName,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmailAttributecreate();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const IsArticlechathandleSubmit = (e) => {
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsArticlechat(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "articlechat" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticlechat(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };

  const IsArticlewhatsappchathandleSubmit = (e) => {
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsArticlewhatsappchat(e.target.checked);
      fetch(
        Config.apiUrl +
          "ArticleProduct/UpdatePublish?id=" +
          ArticleID +
          "&type=" +
          "whatsappchat" +
          "&isPublish=" +
          e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticlewhatsappchat(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };

  const ondeleteDocumentFile = (FileID, i) => {
    let temp = [...CertificateDocumentpath];
    temp.splice(i, 1);
    setCertificateDocumentpath(temp);
  };

  const fileUploadCertificatPost = (IDObj) => {
    if (IDObj != "") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      if (
        DocumentFile != "" ||
        DocumentFile != null ||
        DocumentFile.length > 0
      ) {
        console.log("DocumentFile=>", DocumentFile);
        const byte =
          DocumentFile.map((item) => item.size || 0).reduce(
            (prev, curr) => prev + curr,
            0
          ) || 0;
        fetch(
          Config.apiUrl +
            "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
            UserCompanyId +
            "&UserFileSize=" +
            byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formDataNew = new FormData();
              formDataNew.append("body", DocumentFile[0]);
              formDataNew.append("fileType", "certificate");
              formDataNew.append("targetId", IDObj);
              formDataNew.append("externalLink", "");
              formDataNew.append("displayOrder", "0");
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formDataNew,
              }).then((result) => {
                result.json().then((resp) => {
                  Certificateclerefrom();
                  getAllCertificateList(ArticleID);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        Certificateclerefrom();
        getAllCertificateList(ArticleID);
      }
    }
  };

  const UpdateArticleCertificate = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    if (CertificateList.length > 0) {
      let loginid = localStorage.getItem("loginUserID");
      let certificateIdList = [];
      setCertificatesisloding(true);
      CertificateList.map((item) => {
        if (item.isCertificateselect === true) {
          certificateIdList.push(item._id);
        }
      });
      let ArticleCertificateData = {
        articleId: ArticleID,
        fileType: "ArticleProductCertificate",
        certificateId: certificateIdList,
        userCompanyID: UserCompanyID,
      };

      fetch(Config.apiUrl + "FileUpload/UpdateArticleCertificate", {
        headers: {
          userCompanyID: loginid,
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        method: "POST",
        body: JSON.stringify(ArticleCertificateData),
      })
        .then((result) => {
          result.json().then((resp) => {
            setCertificatesisloding(false);
            swal("Update", "Article  Certificate are Updated.", "success");
            getAllCertificateList(ArticleID);
          });
        })
        .catch((error) => {
          setCertificatesisloding(false);
          console.log(error);
        });
    }
  };
  const isCertificateselectupdate = (itemObj) => {
    let certificateListTemp = [...CertificateList];
    if (certificateListTemp.length > 0) {
      certificateListTemp.map((item) => {
        if (item._id === itemObj._id) {
          if (item.isCertificateselect != true) {
            item.isCertificateselect = true;
          } else {
            item.isCertificateselect = false;
          }
        }
      });
      setCertificateList(certificateListTemp);
    }
  };

  const createDocument = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      CertificateName === null ||
      CertificateName === undefined ||
      CertificateName === ""
    ) {
      retval = false;
      setCertificateNameError("Certificate Name must be filled out");
    }
    if (CertificateWebsite.length > 0) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(CertificateWebsite)
      ) {
        retval = false;
        setCertificateWebsiteError("Enter Valid Website");
      }
    }

    let DataObj = {
      Name: CertificateName,
      Website: CertificateWebsite,
      UserCompanyID: loginid,
    };
    if (retval === true) {
      setIsloading(true);
      fetch(
        Config.apiUrl +
          "Certificate/CheckCertificate?id=" +
          "" +
          "&certificateName=" +
          CertificateName,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(Config.apiUrl + "Certificate/Create", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(DataObj),
            }).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  fileUploadCrrtificatLogoPost(resp._id);
                  toggleSignupAdd();
                  swal("Saved", "Certificate is saved.", "success");
                } else {
                  swal("Sorry!", "Certificate is not saved.", "error");
                }
              });
            });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    } else {
      setIsloading(false);
    }
  };

  const fileUploadCrrtificatLogoPost = (IDObj) => {
    if (IDObj != "") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      if (
        CertificateLogoFile != "" ||
        CertificateLogoFile != null ||
        CertificateLogoFile.length > 0
      ) {
        console.log("CertificateLogoFile=>", CertificateLogoFile);
        const byte = CertificateLogoFile.size;
        fetch(
          Config.apiUrl +
            "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
            UserCompanyId +
            "&UserFileSize=" +
            byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formData = new FormData();
              formData.append("body", CertificateLogoFile);
              formData.append("fileType", "certificatelogo");
              formData.append("targetId", IDObj);
              formData.append("externalLink", "");
              formData.append("displayOrder", "0");
              setIsloading(true);
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  fileUploadCertificatPost(IDObj);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        fileUploadCertificatPost(IDObj);
      }
    }
  };
  const downloadDocumentData = (filename, myUrl) => {
    window.open(filename, "_blank");
  };
  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <ol className="float-xl-right breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/home">Home</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/articleqrcode">Article QR Code</Link>
        </li>
        <li className="active breadcrumb-item">Add New Article</li>
      </ol>
      <h1 className="page-header">Add Loved One </h1>

      <Panel>
        <PanelHeader>
          <h4 className="text-light mb-0">Article QR Code</h4>
        </PanelHeader>
        <PanelBody>
          <div className="row form-group m-b-10">
            <label className="col-form-label col-lg-12 col-xl-2"> Name</label>
            <a href="" target="_blank" rel="noopener noreferrer"></a>
            <div className="col-lg-8 col-xl-6 searchForm">
              <TextareaAutosize
                maxLength={90}
                className="form-control"
                placeholder="Enter Name"
                value={ArticleNumber}
                onChange={(e) => {
                  ArticlenumberhandleInputChange(e);
                }}
                disabled={isArticleDisable == true ? "disabled" : ""}
              />
              <p style={{ textAlign: "right", fontSize: 12, color: "red" }}>
                {ArticleNumber.length}/90
              </p>
              {searchArticlenumber.length > 0 ? (
                <div className="SearchFilterDiv">
                  {searchArticlenumber.map((i) => (
                    <p
                      onClick={() => {
                        ArticlenumbergetbyID(i._id);
                      }}
                    >
                      {i.articleNumber}
                    </p>
                  ))}
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="col-lg-3 col-xl-3 ml-md-2 mt-lg-0 mt-md-3 my-lg-0 my-xs-2">
              <button
                type="button"
                onClick={() => {
                  createArticlesnumber();
                }}
                className="btn btn-primary m-r-5 shadow-add"
                disabled={isArticleDisable == true ? "disabled" : ""}
              >
                Save and Continue
              </button>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <div className="row" style={{ display: show ? "flex" : "none" }}>
        <div className="col-xl-7 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader>
              <h4 className="text-light mb-0">Name</h4>
              <div className="row form-group m-b-0 mr-3">
                <div className="col-md-12">
                  <div className="checkbox checkbox-css checkbox-inline pt-0">
                    <input
                      type="checkbox"
                      checked={IsNameAndCatDisplay}
                      onChange={(e) => {
                        NamecategoryhandleSubmit(e);
                      }}
                      id="inlineCssCheckboxc2"
                    />
                    <label htmlFor="inlineCssCheckboxc2">Publish</label>
                  </div>
                </div>
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="row m-b-10">
                <div className="col-xl-12">
                  <div>
                    <h5 className="m-b-15">
                      <b>Name</b>
                    </h5>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1 " className="">
                      Article Name
                    </label>
                    <div className="row align-items-center">
                      <TextareaAutosize
                        maxLength={90}
                        className="col-xl-6 form-control m-l-10"
                        placeholder="Enter Article Name"
                        value={ArticleName}
                        onChange={(e) => {
                          onChangeArticleName(e);
                        }}
                      />
                      <p
                        style={{
                          fontSize: 12,
                          color: "red",
                          marginTop: "7px",
                          marginLeft: "10px",
                        }}
                      >
                        {ArticleName?.length}/90
                      </p>
                    </div>
                    {ArticleNameError.length > 0 ? (
                      <span style={{ color: "red" }}>{ArticleNameError}</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => {
                  createArticlesNameAndCategorySection();
                }}
                className="btn btn-primary m-r-10 shadow-add"
              >
                Save Changes
              </button>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-5 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader>
              <h4 className="text-light mb-0">QR Code Management</h4>
            </PanelHeader>
            <PanelBody className="p-0">
              <div className="card bg-dark border-0 h-100 rounded-0 overflow-hidden">
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <h3 className="m-b-15 text-white qr-text-size">
                      Create & Share Qr Code
                    </h3>
                  </div>
                  <div className="d-flex row justify-content-center">
                    <div className="col-md-5 d-flex justify-content-center">
                      <div className="rounded qrcode-scan-img">
                        <img
                          src="../assets/img/user/QR.png"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center my-4">
                    {QrCodeStringArticle ? (
                      <button
                        onClick={(e) => {
                          toggleQrCodeModal();
                        }}
                        type="submit"
                        className="btn btn-primary m-r-5 shadow-add"
                      >
                        Create QR Code
                      </button>
                    ) : (
                      <button
                        onClick={async () => {
                          let response =
                            await CheckCheckAPDynamicQrCodeCountenabled();
                          if (response === true) {
                            QrcodegeneratorArticle();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your dynamic qrcode count.",
                              "warning"
                            );
                          }
                        }}
                        type="button"
                        className="btn btn-primary m-r-5 shadow-add"
                      >
                        Create QR Code
                      </button>
                    )}
                    {/* <button
                      onClick={(e) => {
                        toggleQrCodeModal();
                      }}
                      type="submit"
                      className="btn btn-primary m-r-5 shadow-add"
                    >
                      Create QR Code
                    </button> */}
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
      {show == true ? (
        <Panel>
          <PanelHeader>
            <h4 className="text-light mb-0"> {"(Add Images here)"}</h4>
            <div className="row form-group m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    checked={IsArticleImageDisplay}
                    onChange={(e) => {
                      IsArticleImagehandleSubmit(e);
                    }}
                    id="inlineCssCheckboxb6"
                  />
                  <label htmlFor="inlineCssCheckboxb6">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div>
              <h5 className="m-b-15">Images</h5>
            </div>
            <div className="col-md-12 pl-0">
              {ArticlePicsImageList.length > 0 ? (
                <div className="d-flex wrapText">
                  {ArticlePicsImageList.map((subscriber, index) => (
                    <div className="mb-3">
                      <div className="posRelative">
                        <img
                          src={Config.contentUrl + subscriber.filePath}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src =
                              "../assets/img/new-images/images.png";
                          }}
                          className="image-article imageUpload"
                        />
                        <div className="posDelete">
                          <a
                            className="btn btn-danger btndelete shadow-add"
                            onClick={() => ArticleImagedelete(subscriber._id)}
                          >
                            <i className="fa-trash fas"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
            <div className="dropzone needsclick overflow-hidden">
              <Dropzone
                onChangeStatus={handleChangeArticleImageStatus}
                onSubmit={CreateArticlePics}
                accept="image/*,audio/*,video/*"
                styles={{
                  dropzone: { overflow: "hidden", border: "none", padding: 10 },
                }}
                inputContent="Drop files here click to upload"
              />
            </div>
            <div className="mt-3"></div>
          </PanelBody>
        </Panel>
      ) : null}
      {show == true ? (
        <Panel>
          <PanelHeader>
            <h4 className="text-light mb-0">
              {"(Create your landing page here)"}
            </h4>
            <div className="row form-group m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    checked={IsArticleshortDescriptionDisplay}
                    onChange={(e) => {
                      IshortDescriptionandleSubmit(e);
                    }}
                    id="inlineCssCheckboxb21"
                  />
                  <label htmlFor="inlineCssCheckboxb21">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="p-0 panel-body">
              <CKEditor
                editor={Editor}
                config={editorConfiguration}
                data={ArticleShortDescription}
                onChange={(event, editor) => {
                  console.log("Editorkhxbf", editor);
                  const data = editor.getData();
                  onChangeArticleShortDescription(data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
                onReady={(editor) => {
                  editor.ui
                    .getEditableElement()
                    .parentElement.insertBefore(
                      editor.ui.view.toolbar.element,
                      editor.ui.getEditableElement()
                    );
                }}
              />
              {ArticleShortDescriptionError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ArticleShortDescriptionError}
                </span>
              )}
            </div>

            <div className="m-t-10">
              <button
                type="button"
                onClick={() => {
                  createShortDescription();
                }}
                className="btn btn-primary m-r-10 shadow-add"
              >
                {ShortDescriptionisloding && (
                  <i className="m-r-10 fa fa-spin fa-spinner"></i>
                )}
                Save Changes
              </button>
            </div>
          </PanelBody>
        </Panel>
      ) : null}

      {show == true ? (
        <Panel className="border" theme="dark-red">
          <PanelHeader
            className="align-items-center"
            style={{ backgroungColor: "red" }}
          >
            <div className="d-md-flex align-items-center">
              <h4 className="text-light mb-0">Sections</h4>
              <div>
                <button
                  onClick={(e) => {
                    toggleSegmentModal();
                  }}
                  type="submit"
                  className="btn btn-primary btn-sm shadow-add add-new ml-md-2 my-0 my-xs-2"
                >
                  Add New Sections
                </button>
              </div>
            </div>

            <div className="row form-group m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    id="inlineCssCheckboxd1"
                    checked={IsArticleDescriptionDisplay}
                    onChange={(e) => {
                      IsArticleDescriptionDisplyUpdate(e);
                    }}
                  />
                  <label htmlFor="inlineCssCheckboxd1">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>

          <PanelBody className="bg-purple-600">
            {articleSegmentList.length > 0 ? (
              <>
                <Nav className="nav1 justify-content-between mb-3" pills>
                  <div className="row">
                    <NavItem className="navitemdesign p-0">
                      <NavLink className="mb-2"> {displayPosts}</NavLink>
                    </NavItem>
                  </div>
                  <div>
                    <button
                      onClick={(e) => {
                        toggleSegmentModalEdit(e);
                      }}
                      type="submit"
                      className="btn btn-purple m-t-10 shadow-add py-2"
                    >
                      Edit Sections List
                    </button>
                  </div>
                </Nav>
                {/* <TabContent className="bg-white p-15 rounded mb-4" activeTab={activePill}> */}
                <TabContent className="bg-white p-15 rounded mb-4">
                  <TabPane>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="text-light mb-0">Images</h4>
                        <div className="row form-group m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentImageDisplay}
                                id="inlineCssCheckboxd3"
                                onChange={(e) => {
                                  IsArticleSegmentImagehandleSubmit(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd3">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="m-b-10 text-inverse">
                          <div className="col-md-12 pl-0">
                            {ArticleSegmentImageLists !== null ? (
                              <div className="d-flex wrapText">
                                {ArticleSegmentImageLists.map(
                                  (subscriber, index) => (
                                    <div className="mb-3">
                                      <div className="posRelative">
                                        <img
                                          src={
                                            Config.contentUrl +
                                            subscriber.filePath
                                          }
                                          className="image-article imageUpload"
                                        />
                                        <div className="posDelete">
                                          <a
                                            className="btn btn-danger btndelete shadow-add"
                                            onClick={() =>
                                              ArticlesegmentImagedelete(
                                                subscriber._id
                                              )
                                            }
                                          >
                                            <i className="fa-trash fas"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : null}
                          </div>
                          <div className="dropzone needsclick overflow-hidden">
                            <Dropzone
                              // getUploadParams={getArticleUploadParamsSegmentImages}
                              onChangeStatus={
                                handleChangeArticleUploadSegmentImagesStatus
                              }
                              onSubmit={CreateArticleSegmentImages}
                              //accept="image/*,audio/*,video/*"
                              accept="image/*"
                              inputContent={(files, extra) =>
                                extra.reject
                                  ? "Image files only"
                                  : "Drop Image files only here click to upload"
                              }
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                                dropzoneReject: {
                                  borderColor: "red",
                                  backgroundColor: "#DAA",
                                },
                                inputLabel: (files, extra) =>
                                  extra.reject ? { color: "red" } : {},
                              }}
                            />
                          </div>
                          {ArticleUploadSegmentImagesError.length > 0 && (
                            <span style={{ color: "red", marginLeft: 6 }}>
                              {ArticleUploadSegmentImagesError}
                            </span>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>

                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="text-light mb-0">
                          Description (Add Text below)
                        </h4>
                        <div className="row form-group m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentDescriptionDisplay}
                                id="inlineCssCheckboxd5"
                                onChange={(e) => {
                                  IsArticleSegmentDescriptionhandleSubmit(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd5">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="p-0 panel-body">
                          <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={SegmentDescription}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              onChangeSegmentDescription(data);
                              //console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                              console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log("Focus.", editor);
                            }}
                            onReady={(editor) => {
                              editor.ui
                                .getEditableElement()
                                .parentElement.insertBefore(
                                  editor.ui.view.toolbar.element,
                                  editor.ui.getEditableElement()
                                );
                            }}
                          />
                        </div>

                        <div className="m-t-10">
                          <button
                            type="button"
                            onClick={() => {
                              createdeSegmentDescription();
                            }}
                            className="btn btn-primary m-r-10 shadow-add"
                          >
                            Save Changes
                          </button>
                        </div>
                      </PanelBody>
                    </Panel>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="text-light mb-0">
                          Upload Videos (Know more)
                        </h4>
                        <div className="row form-group m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentVideoDisplay}
                                id="inlineCssCheckboxd8"
                                onChange={(e) => {
                                  IsArticleSegmentVideoUpdate(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd8">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="col-md-12 pl-0">
                          {VideosegmentList !== null ? (
                            <div className="d-flex text-break wrapText">
                              {VideosegmentList.map((subscriber, index) =>
                                subscriber.isYouTubeLink === false ? (
                                  <div className="mb-3 posRelativeWidth">
                                    <div className="posRelative">
                                      <VideoTag
                                        src={
                                          Config.contentUrl +
                                          subscriber.filePath
                                        }
                                        className="m-auto image-article imageUpload"
                                      />
                                      <div className="posDelete">
                                        <a
                                          className="btn btn-danger btndelete shadow-add"
                                          onClick={() =>
                                            ArticlesegmentVideodelete(
                                              subscriber._id
                                            )
                                          }
                                        >
                                          <i className="fa-trash fas"></i>
                                        </a>
                                      </div>
                                      <p className="mx-2 text2line">
                                        {subscriber.originalFileName}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="mb-3 posRelativeWidth">
                                    <div className="posRelative">
                                      <img
                                        src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                          subscriber?.youTubeLink
                                        )}/hqdefault.jpg`}
                                        className="m-auto image-article imageUpload"
                                      />
                                      <div className="posDelete">
                                        <a
                                          className="btn btn-danger btndelete shadow-add"
                                          onClick={() =>
                                            ArticlesegmentVideodelete(
                                              subscriber._id
                                            )
                                          }
                                        >
                                          <i className="fa-trash fas"></i>
                                        </a>
                                      </div>
                                      <p className="mx-2 text2line">
                                        {subscriber?.youTubeLink}
                                      </p>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div className="text-inverse">
                          <div className="dropzone needsclick overflow-hidden">
                            <Dropzone
                              onChangeStatus={
                                handleChangeArticleSegmentVideoUploadStatus
                              }
                              onSubmit={CreateArticleSegmentVideo}
                              accept=".mp4"
                              maxSizeBytes={Config.MaximumVideoFileSize}
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                              }}
                              inputContent="Drop video files only here click to upload"
                              submitButtonContent={"Submit"}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-xl-9">
                            <div className="row form-group align-items-center m-b-15">
                              <label className="col-form-label col-md-4">
                                Enter youtube video link
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter youtube video link"
                                  value={youTubleVideoLink}
                                  onChange={onChangeyouTubleVideoLink}
                                />
                              </div>
                              <div className="col-md-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    createyouTubeVideoLink();
                                  }}
                                  className="btn btn-primary m-r-10 shadow-add my-2"
                                >
                                  Add
                                </button>
                              </div>
                              <label className="col-form-label col-md-3"></label>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>

                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="text-light mb-0">
                          Upload documents ( Read further)
                        </h4>
                        <div className="row form-group m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentDocumentDisplay}
                                onChange={(e) =>
                                  IsArticleSegmentDocumentUpdate(e)
                                }
                                id="inlineCssCheckboxd59"
                              />
                              <label htmlFor="inlineCssCheckboxd59">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="col-md-12 pl-0">
                          <Modal
                            isOpen={ArticleSegmentDocumentEditNameisOpen}
                            toggle={ArticleSegmentDocumentEditNameisOpen}
                            className=""
                            onHide={() =>
                              toggleArticleSegmentDocumentEditName()
                            }
                          >
                            <ModalHeader
                              toggle={toggleArticleSegmentDocumentEditName}
                              className="modalheader"
                            >
                              <h5 className="text-white">
                                Edit Article Document
                              </h5>
                            </ModalHeader>
                            <ModalBody>
                              <div className="form-group">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  Edit Article Document
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Article Document"
                                  value={DocumentName}
                                  onChange={(e) => {
                                    onChangeDocumentName(e);
                                  }}
                                />
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <button
                                type="button"
                                onClick={() => {
                                  UpdateArticleDocumentFile();
                                }}
                                className="btn btn-primary m-l-10 m-r-10 shadow-add my-3"
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  toggleArticleSegmentDocumentEditName()
                                }
                                className="btn btn-danger shadow-add my-3"
                              >
                                Discard
                              </button>
                            </ModalFooter>
                          </Modal>
                          {ArticleSegmentDocumentlist !== null ? (
                            <div className="d-flex text-break wrapText">
                              {ArticleSegmentDocumentlist.map(
                                (subscriber, index) => (
                                  console.log("subsvribe=>", subscriber),
                                  (
                                    <div className="mr-3 mt-2 posRelativeWidth">
                                      <div className="posRelative">
                                        <a
                                          href="javascript:void(0)"
                                          className="alignTextCenter"
                                          onClick={() =>
                                            downloadEmployeeData(
                                              subscriber.filePath
                                            )
                                          }
                                          download
                                        >
                                          <img
                                            src="https://deeryamerican.com/wp-content/uploads/2016/12/IMG_9275.ico"
                                            className="img-upload-size"
                                          ></img>
                                        </a>
                                        <div className="posDeletePdf">
                                          <button
                                            className="btn btn-danger btndelete shadow-add"
                                            onClick={() =>
                                              ArticlesegmentDocumentdelete(
                                                subscriber._id
                                              )
                                            }
                                          >
                                            <i className="fa-trash fas"></i>
                                          </button>
                                        </div>
                                        <p>{subscriber?.originalFileName}</p>
                                      </div>
                                    </div>
                                  )
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div className="text-inverse">
                          <div className="dropzone needsclick overflow-hidden">
                            <Dropzone
                              onChangeStatus={
                                handleChangeArticleUploadDocumentStatus
                              }
                              onSubmit={CreateArticleDocument}
                              accept=".pdf"
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                              }}
                              inputContent="Drop pdf files only here click to upload"
                              submitButtonContent={"Submit"}
                            />
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="text-light mb-0">
                          External web site link
                        </h4>
                        <div className="row form-group m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentWebLinkDisplay}
                                id="inlineCssCheckboxd51"
                                onChange={(e) => {
                                  IsArticleSegmentWebLinkupdate(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd51">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="col-xl-9">
                            <div className="row form-group m-b-15">
                              <label className="col-form-label col-md-4">
                                Name
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your link name"
                                  maxLength={30}
                                  value={websitelinkname}
                                  onChange={onChangewebsitelinkname}
                                />
                                <p
                                  style={{
                                    textAlign: "right",
                                    fontSize: 12,
                                    color: "red",
                                  }}
                                >
                                  {websitelinkname.length}/30
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-9">
                            <div className="row form-group align-items-center m-b-15">
                              <label className="col-form-label col-md-4">
                                Enter website link
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter website link"
                                  value={webLink}
                                  onChange={onChangeWebLink}
                                />
                                {WebLinkError.length > 0 && (
                                  <span style={{ color: "red", marginLeft: 6 }}>
                                    {WebLinkError}
                                  </span>
                                )}
                              </div>
                              <div className="col-md-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    createWebLink();
                                  }}
                                  className="btn btn-primary m-r-10 shadow-add my-2"
                                >
                                  Add
                                </button>
                              </div>

                              <label className="col-form-label col-md-3"></label>
                            </div>
                          </div>
                        </div>
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="col-lg-11 panel-body pl-2">
                              <div className="table-responsive">
                                {articleSegmentWebLinkList !== null &&
                                articleSegmentWebLinkList.length > 0 ? (
                                  <table
                                    id="data-table-buttons"
                                    className="table table-bordered table-striped table-td-valign-middle"
                                  >
                                    <thead>
                                      <tr className="gradeA odd">
                                        <th className="text-nowrap">Name</th>
                                        <th className="text-nowrap">
                                          WebLink
                                        </th>

                                        <th
                                          className="text-center text-nowrap"
                                          style={{ width: "15%" }}
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    {articleSegmentWebLinkList !== null ? (
                                      <tbody>
                                        {articleSegmentWebLinkList.map(
                                          (subscriber, index) => (
                                            <tr>
                                              <td>
                                                <p className="breakword mb-0">
                                                  {subscriber.name}
                                                </p>
                                              </td>
                                              <td>
                                                <p className="breakword mb-0">
                                                  {subscriber.linkURL}
                                                </p>
                                              </td>

                                              <td className="text-center">
                                                <a
                                                  href="javascript:void(0)"
                                                  className="btn btn-danger"
                                                  onClick={() => {
                                                    ArticleWeblinkdelete(
                                                      subscriber._id
                                                    );
                                                  }}
                                                >
                                                  <i className="fa-trash fas"></i>
                                                </a>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    ) : null}
                                  </table>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                  </TabPane>
                </TabContent>
              </>
            ) : (
              <></>
            )}
            <Modal
              isOpen={SegmentModalisOpen}
              toggle={SegmentModalisOpen}
              className=""
              onHide={() => {
                toggleSegmentModal();
              }}
            >
              <ModalHeader toggle={toggleSegmentModal} className="modalheader">
                <h5 className="text-white">Add New Segment</h5>
              </ModalHeader>
              <ModalBody>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1 " className="">
                    New Segment Name
                  </label>
                  <input
                    type="text"
                    maxLength={30}
                    className="form-control"
                    placeholder="Enter New Segment Name"
                    value={Title}
                    onChange={(e) => {
                      onChangeArticlesegmentName(e);
                    }}
                  />
                  <p style={{ textAlign: "right", fontSize: 12, color: "red" }}>
                    {Title.length}/30
                  </p>
                  {TitleError.length > 0 ? (
                    <span style={{ color: "red" }}>{TitleError}</span>
                  ) : (
                    ""
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    createArticleSegmentName();
                  }}
                  className="btn btn-primary m-l-10 m-r-10 shadow-add my-3"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => {
                    toggleSegmentModal();
                  }}
                  className="btn btn-danger shadow-add my-3"
                >
                  Discard
                </button>
              </ModalFooter>
            </Modal>

            <Modal
              isOpen={SegmentEditisOpen}
              toggle={SegmentEditisOpen}
              className=""
              onHide={(e) => {
                toggleSegmentModalEdit(e);
              }}
            >
              <ModalHeader
                toggle={toggleSegmentModalEdit}
                className="modalheader"
              >
                <h5 className="text-white mb-0">Edit Segment list</h5>
              </ModalHeader>
              <ModalBody>
                <div className="col-md-12 panel-body pl-2">
                  {articleSegmentList !== null ? (
                    <div>
                      {articleSegmentList.map((subscriber, index) => (
                        <div className="segmentlistbox">
                          <h5 className="mb-0">{subscriber.title}</h5>

                          <div>
                            <div className="d-flex">
                              <a
                                href="javascript:void(0)"
                                className="btnEdit mr-2 NewBtnEdit"
                              >
                                <i
                                  className="fa-pen fas"
                                  onClick={() =>
                                    onClickArticleSegmentNameEdit(subscriber)
                                  }
                                ></i>
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="btn btn-danger"
                                onClick={() =>
                                  ArticlesegmentNamedelete(subscriber._id)
                                }
                              >
                                <i className="fa-trash fas"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              </ModalBody>
            </Modal>

            <Modal
              isOpen={SegmentEditDetailsisOpen}
              toggle={SegmentEditDetailsisOpen}
              className=""
              onHide={() => toggleSegmentEditDetails()}
            >
              <ModalHeader
                toggle={toggleSegmentEditDetails}
                className="modalheader"
              >
                <h5 className="text-white mb-0">Edit Segment</h5>
              </ModalHeader>
              <ModalBody>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1 " className="">
                    Edit Segment Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter New Segment Name"
                    value={Title}
                    maxLength={30}
                    onChange={(e) => {
                      onChangeArticlesegmentName(e);
                    }}
                  />
                  <p style={{ textAlign: "right", fontSize: 12, color: "red" }}>
                    {Title.length}/30
                  </p>
                  {TitleError.length > 0 ? (
                    <span style={{ color: "red" }}>{TitleError}</span>
                  ) : (
                    ""
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    UpdateArticleSegmentName();
                  }}
                  className="btn btn-primary m-l-10 m-r-10 shadow-add my-3"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => {
                    toggleSegmentEditDetails();
                  }}
                  className="btn btn-danger shadow-add my-3"
                >
                  Discard
                </button>
              </ModalFooter>
            </Modal>
          </PanelBody>
        </Panel>
      ) : null}

      <div
        className="row align-items-stretch"
        style={{ display: show ? "flex" : "none" }}
      >
        <div className="col-xl-7 h-100">
          <Panel>
            <PanelHeader>
              <h4 className="text-light mb-0">Certificates</h4>
              <div className="row form-group m-b-0 mr-3">
                <div className="col-md-12">
                  <div className="checkbox checkbox-css checkbox-inline pt-0">
                    <input
                      type="checkbox"
                      checked={IsCertificateDisplay}
                      onChange={(e) => {
                        IsCertificateshandleSubmit(e);
                      }}
                      id="CertificatesCheckboxb1"
                    />
                    <label htmlFor="CertificatesCheckboxb1">Publish</label>
                  </div>
                </div>
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="row">
                <div className="col-md-12">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <label className="col-form-label">
                        Click to display the Certificates for this Product
                      </label>
                    </div>
                    <div className="col-sm-6">
                      {issalf === true ? (
                        <button
                          type="button"
                          onClick={toggleSignupAdd}
                          className="btn btn-primary m-r-10 shadow-add"
                        >
                          Add new Certificate
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className="row align-items-center py-3">
                    <div className="col-sm-12 scroll-behaviour">
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped text-center scrolltable">
                          <thead>
                            <tr className="text-center">
                              <th className="align-middle">Sr.No</th>
                              <th className="align-middle">Select</th>
                              <th className="align-middle">Certificates</th>
                              <th className="align-middle">Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {CertificateList.length > 0 ? (
                              CertificateList.map((item, index) => (
                                <tr className="text-center" key={index}>
                                  <td className="align-middle">{index + 1}</td>
                                  <td className="align-middle">
                                    <div className="checkbox checkbox-5 checkbox-css checkbox-inline pt-0">
                                      <input
                                        type="checkbox"
                                        checked={item.isCertificateselect}
                                        value=""
                                        id={"CssCheckboxae1" + index}
                                        onChange={(e) => {
                                          isCertificateselectupdate(item);
                                        }}
                                      />
                                      <label
                                        htmlFor={"CssCheckboxae1" + index}
                                      ></label>
                                    </div>
                                  </td>
                                  <td className="align-middle">
                                    {/* <img src="../assets/img/user/user-1.jpg" style={{ height: 60 }} /> */}
                                    <img
                                      src={Config.contentUrl + item._LogoPath}
                                      style={{ height: "50px" }}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    ></img>
                                  </td>
                                  <td className="align-middle">{item.name}</td>
                                </tr>
                              ))
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="button"
                onClick={() => {
                  UpdateArticleCertificate();
                }}
                className="btn btn-primary m-l-10 m-r-10 shadow-add"
              >
                {Certificatesisloding && (
                  <i class="m-r-10 fa fa-spin fa-spinner"></i>
                )}
                Save Changes
              </button>

              <Modal isOpen={modalSignupAdd} toggle={toggleSignupAdd}>
                <ModalHeader toggle={toggleSignupAdd} className="modalheader">
                  <h4 className="text-white mb-0">Add Certificates</h4>
                </ModalHeader>
                <ModalBody className="m-0">
                  <div className="row form-group m-b-15">
                    <label className="col-form-label col-md-3">
                      <h5 className="mb-0">Certificates Name</h5>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        maxLength={40}
                        className="form-control"
                        placeholder="Enter Name"
                        value={CertificateName}
                        onChange={onChangeCertificateName}
                      />
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {CertificateName.length}/40
                      </p>
                    </div>
                    {CertificateNameError.length > 0 ? (
                      <span style={{ color: "red" }}>
                        {CertificateNameError}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="row m-b-15">
                    <div className="col-md-3">
                      <h5 className="mb-0">Logo</h5>
                    </div>
                    <div className="col-md-9">
                      <div className="custom-file file-upload-height">
                        <input
                          type="file"
                          onChange={(e) => CertificatesetFile(e)}
                          className="custom-file-input file-upload-height"
                          id="customFile"
                        />
                        <label
                          className="file-upload-1 file-upload-height"
                          for="customFile "
                        >
                          {CertificateLogoPath ? (
                            <img
                              src={CertificateLogoPath}
                              alt="img"
                              className="img-upload-size-1"
                            />
                          ) : (
                            <p className="mb-0">Add Image</p>
                          )}
                          <div className="file-upload-3">
                            <i className="fa-sm ion ion-md-camera"></i>
                          </div>
                        </label>
                      </div>
                    </div>
                    {CertificateLogoFileError.length > 0 ? (
                      <span style={{ color: "red" }}>
                        {CertificateLogoFileError}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="row form-group m-b-15">
                    <label className="col-form-label col-md-3">
                      <h5 className="mb-0">Document</h5>
                    </label>
                    <div className="col-md-9">
                      <div className="custom-file">
                        <input
                          type="file"
                          onChange={(e) => CertificatesetFileDocument(e)}
                          className="custom-file-input"
                          id="customFile"
                          accept="application/pdf"
                        />
                        <label
                          className="custom-file-label file-upload"
                          for="customFile "
                        >
                          Upload
                        </label>
                      </div>
                    </div>
                    {DocumentFileError.length > 0 ? (
                      <span style={{ color: "red" }}>{DocumentFileError}</span>
                    ) : (
                      ""
                    )}
                  </div>

                  {CertificateDocumentpath.map((subscriber, index) => (
                    <div className="row form-group align-items-center m-b-15">
                      <div
                        className="col-md-2 offset-3"
                        key={index}
                        onClick={() => downloadDocumentData(subscriber.FileUrl)}
                      >
                        <img
                          src="../assets/img/new-Images/Pdf.png"
                          style={{ height: "60px" }}
                        ></img>
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Name"
                          value={subscriber.FileName}
                          onChange={(e) => {
                            DcoumnetNameEdit(e, index);
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <button
                          type="button"
                          className="btn btn-danger btn-sm shadow-add"
                          onClick={(e) => {
                            ondeleteDocumentFile(subscriber._id, index);
                          }}
                        >
                          <i className="fa-fw fa-lg fa-trash-alt fas"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                  <div className="row form-group m-b-15">
                    <label className="col-form-label col-md-3">
                      <h5 className="mb-0">Website</h5>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Website"
                        value={CertificateWebsite}
                        onChange={onChangeWebsiteName}
                      />
                      {CertificateWebsiteError.length > 0 ? (
                        <span style={{ color: "red" }}>
                          {CertificateWebsiteError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    type="button"
                    onClick={() => {
                      createDocument();
                    }}
                    className="btn btn-primary shadow-add"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      toggleSignupAdd();
                    }}
                    className="btn btn-danger m-r-10 shadow-add"
                  >
                    Discard
                  </button>
                </ModalFooter>
              </Modal>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-5">
          <div className="row" style={{ display: show ? "flex" : "none" }}>
            <div className="col-xl-12 h-100">
              <Panel>
                <PanelHeader>
                  <h4 className="text-light mb-0">Whats APP Messaging</h4>
                </PanelHeader>
                <PanelBody>
                  <div className="container">
                    <div className="row form-group align-items-center m-b-10">
                      <div className="checkbox checkbox-5 checkbox-css checkbox-inline pt-0">
                        <input
                          type="checkbox"
                          id="distanceisArticlewhatsappchat"
                          checked={isArticlewhatsappchat}
                          onChange={(e) => {
                            IsArticlewhatsappchathandleSubmit(e);
                          }}
                        />
                        <label htmlFor="distanceisArticlewhatsappchat"></label>
                      </div>
                      <label className="col-form-label product-lable">
                        Whats APP Messaging Enable
                      </label>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
            <div className="col-xl-12 h-100">
              <Panel>
                <PanelHeader>
                  <h4 className="text-light mb-0">Email Messaging</h4>
                </PanelHeader>
                <PanelBody>
                  <div className="container">
                    <div className="row form-group align-items-center m-b-10">
                      <div className="checkbox checkbox-5 checkbox-css checkbox-inline pt-0">
                        <input
                          type="checkbox"
                          id="distanceCheckboxae1"
                          checked={IsArticlechat}
                          onChange={(e) => {
                            IsArticlechathandleSubmit(e);
                          }}
                        />
                        <label htmlFor="distanceCheckboxae1"></label>
                      </div>
                      <label className="col-form-label product-lable">
                        Email Messaging Enable
                      </label>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </div>
      {show == true ? (
        <div className="d-flex justify-content-center my-5">
          {QrCodeStringArticle ? (
            <>
              <button
                onClick={(e) => {
                  toggleQrCodeModal();
                }}
                type="submit"
                className="btn btn-lg btn-primary shadow-add"
              >
                Create QR Code
              </button>
              <button className={"btn btn-white btn-shadow p-2 border ml-3"}>
                <img
                  src="../assets/img/user/QR.png"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
            </>
          ) : (
            <>
              <button
                onClick={async () => {
                  let response = await CheckCheckAPDynamicQrCodeCountenabled();
                  if (response === true) {
                    QrcodegeneratorArticle();
                  } else {
                    swal(
                      "oops!",
                      "Sorry! to increase your dynamic qrcode count.",
                      "warning"
                    );
                  }
                }}
                type="button"
                className="btn btn-lg btn-primary shadow-add"
              >
                Create QR Code
              </button>
              <button className={"btn btn-white btn-shadow p-2 border ml-3"}>
                <img
                  src="../assets/img/user/QR.png"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
            </>
          )}
          {/* <button
              type="button"
              className="btn btn-lg btn-primary shadow-add"
              onClick={(e) => {
                toggleQrCodeModal();
              }}
            >
              Create QR Code
            </button>
            <button className={"btn btn-white btn-shadow p-2 border ml-3"}>
              <img
                src="../assets/img/user/QR.png"
                style={{ height: "45px", width: "45px" }}
              ></img>
            </button> */}
        </div>
      ) : null}

      <Modal
        isOpen={QrCodeModalisOpen}
        toggle={QrCodeModalisOpen}
        className="modal-size"
      >
        <ModalHeader toggle={toggleQrCodeModal} className="modalheader">
          <h4 className="text-white mb-0">Create QR code</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row px-3">
            <div className="col-xl-6">
              <div className="row align-items-center">
                <div className="col-xl-4">
                  {ArticlePicsImageList.length > 0 ? (
                    <img
                      src={Config.contentUrl + ArticlePicsImageList[0].filePath}
                      alt
                      className="rounded qrcode-article-image"
                    />
                  ) : (
                    <img
                      src="../assets/img/user/noimage.jpg"
                      alt
                      className="rounded qrcode-article-image"
                    />
                  )}
                  <h5 className="m-t-10 text-center mb-0">{ArticleName}</h5>
                </div>
              </div>
              <div className="m-t-30">
                <div className="row">
                  <h5 className="col-xl-4 mb-0">
                    <b>Article</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6"> {ArticleNumber} </p>
                </div>
              </div>

              {/* {
                selectCombinationID != "" &&
                  selectCombinationID != undefined &&
                  selectCombinationID != null ? (
                  QrCodeString != null &&
                    QrCodeString != undefined &&
                    QrCodeString != "" ? (
                    <button
                      type="button"
                      className="btn btn-lg btn-primary m-l-10 m-r-10 shadow-add my-3"
                      onClick={() => {
                      }}
                    >
                      Create QR Code
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={async () => {
                        let response =
                          await CheckCheckAPDynamicQrCodeCountenabled();
                        if (response === true) {
                          Qrcodegenerator();
                        } else {
                          swal(
                            "oops!",
                            "Sorry! to increase your dynamic qrcode count.",
                            "warning"
                          );
                        }
                      }}
                      className="btn btn-lg btn-primary m-l-10 m-r-10 shadow-add my-3"
                    >
                      Create QR Code
                    </button>
                  )
                ) : QrCodeStringArticle != null &&
                  QrCodeStringArticle != undefined &&
                  QrCodeStringArticle != "" ? (
                  <button
                    type="button"
                    className="btn btn-lg btn-primary m-l-10 m-r-10 shadow-add my-3"
                    onClick={() => {
                      QrcodeArticlealredycreate();
                    }}
                  >
                    Create QR Code
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={async () => {
                      let response =
                        await CheckCheckAPDynamicQrCodeCountenabled();
                      if (response === true) {
                        QrcodegeneratorArticle();
                      } else {
                        swal(
                          "oops!",
                          "Sorry! to increase your dynamic qrcode count.",
                          "warning"
                        );
                      }
                    }}
                    className="btn btn-lg btn-primary m-l-10 m-r-10 shadow-add my-3"
                  >
                    Create QR Code
                  </button>
                )
              } */}

              <button
                type="button"
                onClick={() => {
                  toggleQrCodeModal();
                }}
                className="btn btn-danger btn-lg shadow-add my-3"
              >
                Discard
              </button>
            </div>
            <div className="col-xl-6">
              <div className="dash-box">
                <div style={{ background: "white", padding: "16px" }}>
                  {selectCombinationID != "" &&
                  selectCombinationID != undefined &&
                  selectCombinationID != null ? (
                    QrCodeString != null &&
                    QrCodeString != undefined &&
                    QrCodeString != "" ? (
                      <QRCode value={QrCodeString} id="qrCodeEl" size={200} />
                    ) : (
                      <img
                        src="/assets/img/new-Images/qr-code-scanner.jpg"
                        style={{ height: "200px" }}
                      ></img>
                    )
                  ) : QrCodeStringArticle != null &&
                    QrCodeStringArticle != undefined &&
                    QrCodeStringArticle != "" ? (
                    <QRCode
                      value={QrCodeStringArticle}
                      id="ArticleqrCodeEl"
                      size={200}
                    />
                  ) : (
                    <img
                      src="/assets/img/new-Images/qr-code-scanner.jpg"
                      style={{ height: "200px" }}
                    ></img>
                  )}
                </div>

                <div className="my-2">
                  {selectCombinationID != "" &&
                  selectCombinationID != undefined &&
                  selectCombinationID != null ? (
                    QrCodeString != null &&
                    QrCodeString != undefined &&
                    QrCodeString != "" ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 m-r-5"
                          onClick={printQrcode}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 m-r-5"
                          onClick={downloadQRCode}
                        >
                          Download
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5"
                          onClick={() => {
                            toggleToEmailAttributecreate();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : null
                  ) : QrCodeStringArticle != null &&
                    QrCodeStringArticle != undefined &&
                    QrCodeStringArticle != "" ? (
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn btn-warning m-b-5 m-r-5"
                        onClick={printQrcodeArticle}
                      >
                        Print
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning m-b-5 m-r-5"
                        onClick={downloadQRCodeArticle}
                      >
                        Download
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning m-b-5 m-r-5"
                        onClick={() => {
                          toggleToEmail();
                        }}
                      >
                        Send
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={isToEamil} toggle={toggleToEmail}>
        <ModalHeader toggle={toggleToEmail} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="d-flex align-items-center mt-2"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="btn btn-link m-l-10"
                onClick={SubToEmailaddClick}
              >
                <i className="text-success fa-fw fa-lg fa-plus-circle fas"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSend();
              }}
              className="btn btn-primary btn-sm m-r-5 shadow-add"
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmail();
              }}
              className="btn btn-danger btn-sm shadow-add"
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={isToEamilAttribute} toggle={toggleToEmailAttributecreate}>
        <ModalHeader
          toggle={toggleToEmailAttributecreate}
          className="modalheader"
        >
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="d-flex align-items-center mt-2"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="btn btn-link m-l-10"
                onClick={SubToEmailaddClick}
              >
                <i className="text-success fa-fw fa-lg fa-plus-circle fas"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSendAttributecreate();
              }}
              className="btn btn-primary btn-sm m-r-5 shadow-add"
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmailAttributecreate();
              }}
              className="btn btn-danger btn-sm shadow-add"
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Addnewarticle;
